module.exports = __webpack_public_path__ + "static/Group 6 Copy-015a0b3c42929270f35bf2f58e59bfaa.png";